import type { ReactNode } from 'react'

import { useEffect } from 'react'
import { useStore } from 'store'

import useIsClientPage from 'hooks/useIsClientPage'
import useIsAdminPage from 'hooks/useIsAdminPage'
import Spinner from 'components/Spinner'

export default function AuthProvider({ children }: { children: ReactNode }) {
  const { getLoginUser, currentLoginUser, getLoginUserClientPanel, loading } = useStore()
  const isClientPage = useIsClientPage()
  const isAdminPage = useIsAdminPage()

  useEffect(() => {
    const getUser = async () => {
      if (isClientPage) {
        await getLoginUserClientPanel()
      }

      if (isAdminPage) {
        await getLoginUser()
      }
    }

    getUser()
  }, [isClientPage, isAdminPage]) // eslint-disable-line

  if (loading.getLoginUser || loading.getLoginUserClientPanel) return <Spinner />

  if (!currentLoginUser?.login && process.env.NODE_ENV !== 'development' && isAdminPage) return null

  return <>{children}</>
}
